<div class="input-container" [ngClass]="containerCss">
  <div [ngClass]="contentCss">
    <label [ngClass]="[labelCss, labelRequired ? 'label-required' : '']" *ngIf="attrLabel">{{ attrLabel }}</label>
  </div>
  <div class="display-flex flex-column fill">
    <div class="input-wrapper fill" [ngClass]="inputCss">
      <mat-form-field
        floatLabel="never"
        [ngClass]="[
          markAsInvalid ||
          (errors && showValidationErrorOrSubmitted) ||
          (displayCounter && control?.value?.length > maxCounter)
            ? 'invalid'
            : '',
          errors ? 'error-section' : '',
          control.value || control.value === 0 ? 'filled' : '',
          disabled ? 'disabled' : ''
        ]"
        [attr.aria-invalid]="errors && showValidationErrorOrSubmitted"
      >
        <input
          #inputControl
          [ngClass]="[
            (errors && showValidationErrorOrSubmitted) ||
            markAsInvalid ||
            (displayCounter && control?.value?.length > maxCounter)
              ? 'invalid'
              : '',
            errors ? 'error-section' : '',
            control.value || control.value === 0 ? 'filled' : '',
            disabled ? 'disabled' : ''
          ]"
          matInput
          [type]="attrType"
          [formControl]="control"
          [placeholder]="attrPlaceholder"
          [name]="attrName"
          [autocomplete]="attrAutocomplete ? 'on' : 'off'"
          [mask]="attrMask"
          [readonly]="readonly"
          [thousandSeparator]="attrThousandSeparator"
          [dropSpecialCharacters]="attrDropSpecialCharacters"
          [validation]="true"
          [attr.aria-invalid]="(errors && showValidationErrorOrSubmitted) || markAsInvalid"
          (blur)="onBlur($event)"
          (keydown.enter)="keydownEnter($event)"
        />
        <span *ngIf="prefix" matPrefix>{{ prefix }}</span>
      </mat-form-field>
    </div>
    <div
      *ngIf="displayCounter"
      class="placeholder counter"
      [ngClass]="control?.value?.length > maxCounter ? 'red3' : ''"
    >
      [{{ control?.value?.length || 0 }}/{{ maxCounter }}]
    </div>
    <app-input-error
      *ngIf="errorSection && errors && displayErrorContent"
      [errors]="errors"
      [visible]="markAsInvalid || (errors && showValidationErrorOrSubmitted)"
    ></app-input-error>
  </div>
</div>
